import React from 'react';
import {connect} from 'react-redux';
import {useTranslation} from "react-i18next";
import {applicationFeatures, resourcePoolTypes} from "../../../utilities/constants";
import AzureResourcePoolRow from "./AzureResourcePoolRow";
import {getAzureResourcePoolIds} from "../../../reselect/selectors";
import {AddButtonHeader} from "../../common/Button/Button";
import {includesSome, isAllTruthy, isNotEmptyNorFalsy} from "../../../utilities/helperFunctions";
import ResourcePoolModel from "../../../models/settings/ResourcePoolModel";
import {StatusLabel} from "../../common/Common";

function AzureResourcePoolTable(props) {
    const {prerequisites, azureResourcePoolIds, showAzureResourcePoolForm, userFeatures} = props;
    const {t} = useTranslation(['aria', 'resourcePool', 'common']);

    const canAddResourcePool = includesSome(userFeatures, [applicationFeatures.ADD_RESOURCE, applicationFeatures.ADD_RESOURCE_POOLS]);
    const isNotEmpty = isNotEmptyNorFalsy(azureResourcePoolIds);
    if (!canAddResourcePool && !isNotEmpty) {
        return null;
    }

    return (
        <div className="display-item">
            <AddButtonHeader aria-label={t('aria:hiddenAssistText.addAzureResourcePool')} text={t('resourcePool:label.azureName')}
                canModify={canAddResourcePool}
                onClick={showAzureResourcePoolForm} isDisabled={!isAllTruthy(prerequisites)}
            />

            {canAddResourcePool && !prerequisites.nuixLicenceSource &&
                <StatusLabel message={t('resourcePool:message.noNuixLicenceSources', {type: 'Azure'})}
                    style={{margin: '0.5rem 0'}}/>
            }

            {isNotEmpty &&
                <div className="display-table">
                    <div className="table-header-group">
                        <div className="table-header" style={{width: '4rem'}}/>

                        <div className="table-header">
                            <label className="label is-bold">
                                {t('common:label.name')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.tenant')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.appId')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.subscriptionId')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.vmNames')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.tags')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.nuixLicenceSource')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.targetWorkers')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.minWorkers')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.instanceIdleAction')}
                            </label>
                        </div>
                        <div className="table-header">
                            <label className="label is-bold">
                                {t('resourcePool:label.forceIdleAction')}
                            </label>
                        </div>
                    </div>

                    <div className="table-row-group">
                        {azureResourcePoolIds.map(id => <AzureResourcePoolRow key={id} resourcePoolId={id}/>)}
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => {
    const {nuixLicenceSourceDetailsMap, currentUser: {features}} = state;

    const prerequisites = {
        nuixLicenceSource: isNotEmptyNorFalsy(nuixLicenceSourceDetailsMap)
    };

    return {
        prerequisites,
        azureResourcePoolIds: getAzureResourcePoolIds(state),
        userFeatures: features
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showAzureResourcePoolForm: () => dispatch(ResourcePoolModel.actionCreators.showForm({type: resourcePoolTypes.AZURE}))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AzureResourcePoolTable);